export const pricingPageStyles = {
	creditsSection: {
		width: '100%',
		height: 'calc(100vh - 64px)',
		overflow: 'scroll',
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center',
		gap: '32px',
		flex: 1,
	},
	creditsWrapper: {
		width: '100%',
		maxWidth: '1500px',
		padding: { xs: '40px 16px 16px', sm: '40px 32px 16px', md: '40px 103px 24px' },
		display: 'flex',
		gap: '120px',
		flexDirection: 'column',
		alignItems: 'center',
		flex: 1,
	},
	fabButton: {
		position: 'absolute',
		right: '20px',
		bottom: '20px',
		height: '48px',
		width: '48px',
	},
	subtitle(isHighlighted) {
		return {
			width: 'fit-content',
			alignSelf: 'center',
			padding: isHighlighted ? '0px 8px' : '0',
			color: 'colors.light4',
			backgroundColor: 'transparent',
			borderRadius: isHighlighted ? '8px' : '0',
		};
	},
};
